/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MonthlyCoveragePlanSummaryDto } from './monthlyCoveragePlanSummaryDto.schema';

export const IReadOnlyListOfMonthlyCoveragePlanSummaryDto = zod.array(zod.lazy(() => MonthlyCoveragePlanSummaryDto));

export type IReadOnlyListOfMonthlyCoveragePlanSummaryDto = zod.input<typeof IReadOnlyListOfMonthlyCoveragePlanSummaryDto>;
export type IReadOnlyListOfMonthlyCoveragePlanSummaryDtoOutput = zod.output<typeof IReadOnlyListOfMonthlyCoveragePlanSummaryDto>;
